import PropTypes from 'prop-types';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Box, Grid, IconButton, useMediaQuery } from '@mui/material';

// third-party
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

// assets
import { IconChevronRight, IconChevronLeft } from '@tabler/icons';

// styles
const Images = styled('img')({
    width: '90%',
    height: '90%',
    marginBottom: 32,
    backgroundSize: 'cover',
    objectFit: 'cover',
});

function SampleNextArrow({ onClickHandler }) {

    const theme = useTheme();

    return (
        <IconButton
            onClick={onClickHandler}
            sx={{
                position: 'absolute',
                zIndex: 2,
                top: 'calc(100% - 50px)',
                cursor: 'pointer',
                background: `${theme.palette.background.paper} !important`,
                width: { xs: '40px !important', xl: '45px !important' },
                height: { xs: '40px !important', xl: '45px !important' },
                boxShadow: '0px 24px 38px rgba(9, 15, 37, 0.07)',
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    transform: 'scale(9)'
                },
                svg: {
                    height: { md: 20, lg: 40, xl: '40px' },
                    width: { md: 20, lg: 40, xl: '40px' }
                },
                right: { xs: '50px', md: '80px', lg: '120px', xl: '20px' }
            }}
        >
            <IconChevronRight fontSize={25} color={theme.palette.grey[900]} aria-label="click to slide change left side" />
        </IconButton>
    );
};

SampleNextArrow.propTypes = {
    onClickHandler: PropTypes.func
};

function SamplePrevArrow({ onClickHandler }) {

    const theme = useTheme();

    return (
        <IconButton
            onClick={onClickHandler}
            sx={{
                position: 'absolute',
                zIndex: 2,
                top: 'calc(100% - 50px)',
                cursor: 'pointer',
                background: `${theme.palette.background.paper} !important`,
                width: { xs: '40px !important', xl: '45px !important' },
                height: { xs: '40px !important', xl: '45px !important' },
                boxShadow: '0px 24px 38px rgba(9, 15, 37, 0.07)',
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    transform: 'scale(9)'
                },
                svg: {
                    height: { md: 20, lg: 40, xl: '40px' },
                    width: { md: 20, lg: 40, xl: '40px' }
                },
                left: { xs: '50px', md: '80px', lg: '120px', xl: '20px' }
            }}
        >
            <IconChevronLeft fontSize={25} color={theme.palette.grey[900]} aria-label="click to slide change right side" />
        </IconButton>
    );
};

SamplePrevArrow.propTypes = {
    onClickHandler: PropTypes.func
};

const Items = ({ image }) => {

    return (
        <>
            <Images
                src={image}
                alt="dashboard"
                sx={{
                    alignItems: 'center',
                    width: '70%',
                    height: '70%',
                    objectFit: 'contain',
                    direction: 'initial'
                }}
            />
        </>
    );
};

Items.propTypes = {
    image: PropTypes.string,
};

const CarouselImage = ({ imageArray }) => {

    const theme = useTheme();
    const matchUpSM = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            <Grid container spacing={7.5} justifyContent="center" sx={{ px: 1.25 }}>
                <Grid item xs={12}>
                    <Box
                        className="preBuildDashBoard-slider"
                        sx={{
                            textAlign: 'center',
                            direction: 'initial',
                            paddingTop: 5,
                            '.slider': { height: { xs: 'auto' }, '& .slide:not(.selected)': { transformOrigin: 'center !important' } }
                        }}
                    >{imageArray.length > 1 ? (<Carousel
                        showArrows
                        showThumbs={false}
                        showIndicators={false}
                        centerMode={!matchUpSM}
                        centerSlidePercentage={50}
                        infiniteLoop
                        autoFocus
                        emulateTouch
                        swipeable
                        autoPlay
                        interval={2000}
                        renderArrowPrev={(onClickHandler, hasPrev, label) =>
                            hasPrev && <SamplePrevArrow onClickHandler={onClickHandler} hasPrev={hasPrev} label={label} />
                        }
                        renderArrowNext={(onClickHandler, hasNext, label) =>
                            hasNext && <SampleNextArrow onClickHandler={onClickHandler} hasNext={hasNext} label={label} />
                        }
                    >
                        {imageArray.map((image, index) => (
                            <Items image={image} key={index} />
                        ))}
                    </Carousel>) : (<Items image={imageArray[0]} />)}

                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

export default CarouselImage;
